import React, { useState, createContext, useContext } from 'react';
import * as Icon from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"
import LeftMenu from "./LeftMenu"
import { BrowserRouter, useLocation } from "react-router-dom";
import AppProvider from "context/app"
const { Header, Content, Footer, Sider } = Layout;

const AppLayoutContext = createContext();


const MainLayout = () => {
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const {
    token
  } = theme.useToken();

  const location = useLocation();
  if (["/login", "/register"].includes(location.pathname.toLowerCase())) {
    window.location = "./";
    return "";
  }

  const isShowLeftMenu = location.pathname !== "/login" && location.pathname !== "/reset-password" && location.pathname !== "/register";

  return (
    <AppLayoutContext.Provider value={{ menuCollapsed, setMenuCollapsed }}>
      <Layout
        style={{
          minHeight: '100vh',
        }}
      >
        {isShowLeftMenu && <LeftMenu />}

        <Layout>
          {/* <Header
            style={{
              padding: 0,
              background: colorBgContainer,
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          /> */}
          <Content
            style={{
              margin: '0 16px',

            }}
          >

            <div
              style={{

                minHeight: "100vh",
                background: token.colorBgLayout,

              }}
            >
              <PageRoutes></PageRoutes>
            </div>
          </Content>

        </Layout>
      </Layout>
    </AppLayoutContext.Provider>
  );
};

const useAppLayoutContext = () => {
  return useContext(AppLayoutContext);
}


const App = () => {
  return (
    <BrowserRouter basename="/">
      <AppProvider>
        <MainLayout></MainLayout>
      </AppProvider>
    </BrowserRouter>
  )
}
export { useAppLayoutContext }
export default App;